module.exports = __webpack_public_path__ + "static/media/AramarkEliteBuyer.89be1c38.png";